<template>
	<div>

		<div class="form_content2">
			<template v-for="(value, index) in fieldlist">
				<!-- group_id -->
				<div class="form_items Flexalign"  v-if="value.is_show && value.group_id == types"
					:class="itemClass(value)">
					<!--  -->
					<template v-if="value.field_type === 1">
						<span class="tit">
							{{ value.field }}:
							
						</span>

						<el-input clearable @blur="fn_Required(value)" :maxlength="value.maxLength" :disabled="value.disabled" show-word-limit
							v-model="value.content" >
						</el-input>
						<!--  -->
					</template>

					<template v-else-if="value.field_type === 2">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 多行 -->
						<el-input clearable @blur="fn_Required(value)" :maxlength="value.maxLength" :disabled="value.disabled" show-word-limit
							type="textarea" :rows="2"  v-model="value.content">
						</el-input>
						<!--  -->
					</template>

					<template v-else-if="value.field_type === 3">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 时间 -->
						<el-date-picker @blur="fn_Required(value)" v-model="value.content" :disabled="value.disabled"
						 value-format="timestamp"
							type="datetime" >
						</el-date-picker>
						<!--  -->
					</template>

					<template v-else-if="value.field_type === 4">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 数字 -->
						<el-input clearable @blur="fn_Required(value)" :maxlength="value.maxLength" :disabled="value.disabled"
							v-model="value.content"  oninput="value=value.replace(/[^0-9.]/g,'')">
						</el-input>
						<!--  -->
					</template>


					<template v-else-if="value.field_type === 5">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 单选 -->
						<div :class="{'isdisabled': !value.field_list.length}">
							<el-select v-model="value.content" @change="fn_Required(value)" :disabled="value.disabled">
								<el-option v-for="(item2, index2) in value.field_list" :key="item2.name" :label="item2.name"
									:value="item2.id">
								</el-option>
							</el-select>
						</div>
						
						<!--  -->
					</template>


					<template v-else-if="value.field_type === 6">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 多选 -->
						<el-select multiple  @change="fn_Required(value)" v-model="value.content" :disabled="value.disabled">
							<el-option v-for="(item2, index2) in value.field_list" :key="item2.name" :label="item2.name"
								:value="item2.id">
							</el-option>
						</el-select>
						<!--  -->
					</template>
					<template v-else-if="value.field_type === 7">
						<!-- 附件 -->
						<span class="tit" v-if="value.custom">
							{{ value.field }}:
						</span>
						<enclofile :ispowerDel="ispowerDel" :disabled="value.disabled" :enclist="value.content"
							:fieldid="value.id" @fndelet="fndelet" :filenum="value.field_list.fileNum"
							:filesize="value.field_list.fileSize" @setupfile="setupfile">
						</enclofile>
						<!--  -->
					</template>
					<!--  -->
					<template v-else-if="value.field_type === 8">
						<!--  -->
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 图片 -->
						<enclofile :ispowerDel="ispowerDel" :disabled="value.disabled" :enclist="value.content"
							:fieldid="value.id" :filenum="value.field_list.imgNum" @fndelet="fndelet"
							@setupfile="setupfile" accept=".png,.jpg,.jpeg">
						</enclofile>
						<!--  -->
					</template>
					<!--  -->

					<template v-else-if="value.field_type === 9">
						<!-- 产品 -->
						<addproduct :ispowerEdit="ispowerEdit" :ispowerDel="ispowerDel" :islook="value.is_show"
							:isedit="!value.disabled" :isnodata="false" :show="show" :disabled="value.disabled"
							:pro_list="value.content" :fieldid="value.id" @eidht="headeidht" @deleteds="headdeleteds"
							@pushpro="headpushpro" @procomkl="headprocomkl"></addproduct>
						<!--  -->
					</template>
					<template v-else-if="value.field_type === 12">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!-- 客户 -->
						<div :class="{'isdisabled': value.disabled }">
							<newgratedropdown :seltype="1"  :singleval="value.singleval" 
							:clearable="false" @outlet="fn_outlet($event, value.id)">
							</newgratedropdown>
						</div>
					</template>
					<!-- 地址选择 -->
					<template v-else-if="value.field_type === 18">
						<span class="tit">
							{{ value.field }}:
						</span>
						<!--  -->
						<areaselect
						:datas="value.content" @retarea="fnrareas"
						></areaselect>
					</template>
					<!--  -->
					
				</div>

			</template>
		</div>


	</div>
</template>


<script>
	import addproduct from "./newpup/addproduct";
	import enclofile from "./newpup/enclofile";
	import areaselect from "@/components/tabledata/areaselect.vue";
	
	import newgratedropdown from "@/components/integrated/newgratedropdown.vue";
	import {
		lxrl_list_contact,
	} from "network/hk_customer";
	export default {
		components: {
			newgratedropdown,
			
			addproduct,
			enclofile,
			areaselect,
		},
		props: {
			ispowerEdit: {
				type: Boolean,
				default: true,
			},
			ispowerDel: {
				type: Boolean,
				default: true,
			},
			types: {
				type: Number,
				default: 0,
			},
			// 是否获取全部客户 还是获取我负责的
			allCusts: {
				type: Boolean,
				default: false,
			},
			style2: {
				type: Boolean,
				default: false,
			},

			// 字段列表
			fieldlist: {
				type: Array,
				default: () => {
					return []
				},
			},
		},

		watch: {
			fieldlist() {
				this.setLxrdata()
			},
		},
		created() {
			this.setLxrdata()
		},
		methods: {
			// 检查是否有客户字段,有客户需要获取联系人
			setLxrdata() {
				let index1 = this.findType(12)
				if (index1 != -1) {
					let id = this.fieldlist[index1] ? this.fieldlist[index1].content : '';
					if (id) {
						this.getlxrList(id)
					}
				}
			},
			// 动态下拉框选择
			fn_outlet(e, id) {
				let index = this.findIndex(id)
				this.fieldlist[index].content = e.id
				this.fieldlist[index].select_field = e.name
				if (e.seltype == 1) { // 客户
					// 联系人
					this.getlxrList(e.id)
				}
			},
			// 获取 联系人  10
			getlxrList(customer_id) {
				if (!customer_id || typeof(customer_id) != 'number') return;
				let data = {
					page: 1,
					sort_type: 1,
					pagesize: 99, // 	是	int	每页数量
					customer_id,
				};
				lxrl_list_contact(data).then((res) => {
					if (res.code == 10000) {
						let arr = res.result.data || [];
						for (let item of arr) {
							item.id = item.contact_id
						}
						let index2 = this.findName('联系人')
						this.fieldlist[index2].field_list = arr
						let content = arr[0].contact_id
						let select_field = arr[0].name
						this.fieldlist[index2].content = content
						this.fieldlist[index2].select_field = select_field
					}
				});
			},
			findType(field_type) {
				let index = this.fieldlist.findIndex(v => v.field_type == field_type)
				if (index != -1 && this.fieldlist[index]) {
					return index
				} else {
					return -1
				}
			},
			findIndex(id) {
				let index = this.fieldlist.findIndex(v => v.id == id)
				if (index != -1 && this.fieldlist[index]) {
					return index
				}
			},
			findName(field) {
				let index = this.fieldlist.findIndex(v => v.field_sign == field || v.field == field)
				if (index != -1 && this.fieldlist[index]) {
					return index
				}
			},
			// ----------------------------------------------
			
			fnrareas(e){
				console.log(e,'fnrareas')
				if(e) {
					let flag1 = this.findTpye(18)
					if (flag1) { // 选择联系人
						let index_1 = this.fieldlist.findIndex(v => v.field_sign == '收货地址')
						// 找到联系人字段，清空联系人字段的值
						if (index_1 != -1 && this.fieldlist[index_1]) {
							this.fieldlist[index_1].content = e
						}
					}
				}
				
			},
			
			fn_Required(value){
				if(value.required) {
					if(!value.content) {
						value.isblur = true
					}
					else {
						value.isblur = false
					}
					this.$forceUpdate()
				}
			},
			
			itemClass(value) {
				return {
					'cl_column': value.column,
					'cl_blur': value.isblur,
					'required': value.required,
					'style2': this.style2,
		
				}
			},
			
			// 根据字段类型查询字段是否存在
			findTpye(field_type) {
				return this.fieldlist.some(v => v.field_type == field_type)
			},
		},
		data() {
			return {
				dragshow: false,
				// 当前用户成员id
				member_id: '',
				member_name: '',
			
				
			}
		},
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-select__tags>span {
		display: block;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.form_content2 {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			max-width: 1400px;
			.form_items.cl_column {
				flex: none;
				align-items: flex-start;
				min-width: 960px;
				width: 100%;
				/deep/ .el-textarea {
					min-width: 960px;
					width: 100%;
				}
			}
			.form_items.cl_blur {
				/deep/ .el-textarea {
					border:solid 1px #f56c6c !important;
				}
				/deep/ .el-input {
					input{
						border:solid 1px #f56c6c !important;
					}
				}
				/deep/ .el-select {
					.el-input {
						input{
							border:solid 1px #f56c6c !important;
						}
					}
				}
			}
			
			.form_items.required{
				.tit::before{
					content: '*';
					display: inline-block;
					color: red;
				}
			}
			.form_items.style2{
				min-width: 500px !important;
				/deep/ .el-textarea {
					min-width: 500px !important;
					width: 500px !important;
				}
				/deep/ .el-input {
					min-width: 500px !important;
					width: 500px !important;
				}
			}
			
			.form_items {
				// 
				width: 50%;
				// border: solid 1px pink;
				// flex: 1;
				margin-bottom: 14px;
				.tit {
					min-width: 100px;
					font-size: 14px;
					// color: rgba(56, 56, 56, 1);
					white-space: nowrap;
					text-align: right;
					margin-right: 10px;
					position: relative;
					color: rgba(96, 98, 102, 1);
				}
			}
		
		}
		.form_items div{
			width: 100% !important;
		}
		/deep/ .form_items .el-input {
			// min-width: 474px;
			// max-width: 580px ;
			width: 100% !important;
		}
		/deep/ .form_items .el-select {
			
			width: 100% !important;
		}
		/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
			width: 100% !important;
		}
		
		
		
		/deep/ .el-input.is-disabled .el-input__inner {
			color: rgba(96, 98, 102, 1) !important;
		}
		/deep/ .el-textarea.is-disabled .el-textarea__inner {
			color: rgba(96, 98, 102, 1) !important;
		}
</style>